var _a;
import { DisputeReason } from '../const/disputeReason';
var cancelledPurchasesReasonKey = 'confirmationDisclaimer.cancelledPurchases';
var creditReasonKey = 'confirmationDisclaimer.credit';
var incorrectAmountReasonKey = 'confirmationDisclaimer.incorrectAmount';
var noDocumentsRequestedReasonKey = 'confirmationDisclaimer.noDocumentsRequested';
var nonReceiptOfGoodsServicesReasonKey = 'confirmationDisclaimer.nonReceiptOfGoodsServices';
var paidByOtherMeansReasonKey = 'confirmationDisclaimer.paidByOtherMeans';
var qualityOfGoodsServicesReasonKey = 'confirmationDisclaimer.qualityOfGoodsServices';
var DisputeReasonDescriptionTranslationKeys = (_a = {},
    _a[DisputeReason.INCORRECT_SALE_AMOUNT] = incorrectAmountReasonKey,
    _a[DisputeReason.DOUBLE_CHARGE] = incorrectAmountReasonKey,
    _a[DisputeReason.CREDIT_NOT_POSTED] = creditReasonKey,
    _a[DisputeReason.CREDIT_POSTED_AS_DEBIT] = creditReasonKey,
    _a[DisputeReason.CREDIT_POSTED_DOES_NOT_BELONG_TO_ACCOUNT] = creditReasonKey,
    _a[DisputeReason.INCORRECT_CREDIT_AMOUNT] = creditReasonKey,
    _a[DisputeReason.CANCELLED_ORDER_OR_RESERVATION] = cancelledPurchasesReasonKey,
    _a[DisputeReason.CANCELLED_RECURRING_TRANSACTION] = cancelledPurchasesReasonKey,
    _a[DisputeReason.NON_RECEIPT_OF_GOODS_SERVICES] = nonReceiptOfGoodsServicesReasonKey,
    _a[DisputeReason.MERCHANDISE_NOT_RECEIVED] = nonReceiptOfGoodsServicesReasonKey,
    _a[DisputeReason.QUALITY_OF_GOODS_SERVICES] = qualityOfGoodsServicesReasonKey,
    _a[DisputeReason.PAID_BY_OTHER_MEANS] = paidByOtherMeansReasonKey,
    _a[DisputeReason.NO_WRITTEN_DISCLOSURES_AT_POS] = noDocumentsRequestedReasonKey,
    _a[DisputeReason.PROVIDER_MISLED_CUST_ON_TERMS] = noDocumentsRequestedReasonKey,
    _a[DisputeReason.PROVIDER_SUBMITTED_WITHOUT_MY_KNOWLEDGE_CONSENT] = noDocumentsRequestedReasonKey,
    _a[DisputeReason.MULTIPLE_REASONS_DISPUTES] = noDocumentsRequestedReasonKey,
    _a);
var getTranslationForTransactionDisputeReasonDocs = function (disputeReason) {
    // NOTE: Letter casing might vary from API response, so we deal with that here
    var upperCaseDisputeReason = disputeReason.toUpperCase();
    if (!DisputeReasonDescriptionTranslationKeys[upperCaseDisputeReason]) {
        return '';
    }
    return DisputeReasonDescriptionTranslationKeys[upperCaseDisputeReason];
};
export default getTranslationForTransactionDisputeReasonDocs;
//# sourceMappingURL=getTranslationForTransactionDisputeReasonDocs.js.map